import { render, staticRenderFns } from "./TeamCreateTeamInfo.vue?vue&type=template&id=45981297&"
import script from "./TeamCreateTeamInfo.vue?vue&type=script&lang=ts&"
export * from "./TeamCreateTeamInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports